import { ReactElement, useCallback, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarConfig } from '@config/sidebar.config';
import { useProfileQuery } from '@services/hooks/profile/useProfileQuery';
import { ProfileData } from '@services/hooks/profile';
import { useGetRxDb } from '@hooks/getRxdbData';
import { onProfileImageError } from '@helper/utils';
import { overlayRemoveFadeAction } from '@components/common/sort';
import { useSiderToggleMenu } from '@store/useSiderToggleMenu';
import { LogoutButton } from '@components/common';
import { MenuItem } from '@components/common/sidebar/menuItem';

export const Sidebar = (): ReactElement => {
	const { isOpen, setModal } = useSiderToggleMenu();

	useProfileQuery();
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const [profileImageData, setProfileImageData] = useState<string>();

	useEffect(() => {
		if (profile?.[0]?.profile_image_c) {
			setProfileImageData(profile[0].profile_image_c);
		}
	}, [profile]);

	const toggleMenu = useCallback(() => {
		overlayRemoveFadeAction(() => setModal(false), 'sidebar-overlay');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<aside id="sidenav" className={`sidebar ${isOpen ? 'sidebar--open' : ''}`.trim()}>
				<div className="sidebar__content">
					<div className="sidebar__header">
						<div className="sidebar__header-title">Menu</div>
						<button type="button" aria-label="close sidebar" className="sidebar__close-btn" onClick={toggleMenu}>
							<span className="icon-cross" />
						</button>
					</div>

					<nav className="sidebar__nav">
						<ul className="sidebar__menu-list">
							{SidebarConfig.map((menu) => (
								<MenuItem key={menu.key} menu={menu} toggleMenu={toggleMenu} />
							))}
						</ul>
					</nav>

					<div className="sidebar__profile-container">
						<ul className="sidebar__menu-list sidebar__menu-list--profile">
							<li>
								<NavLink
									to="/help-and-support"
									className="sidebar__link"
									aria-label="Mpower Support"
									onClick={toggleMenu}
								>
									<span className="icon-support" /> Mpower Support
								</NavLink>
							</li>
							<li>
								<LogoutButton />
							</li>
						</ul>
						<NavLink to="/profile" className="sidebar__profile" aria-label="Edit Profile" onClick={toggleMenu}>
							<picture>
								<img
									alt="User Profile"
									title="User Profile"
									width="48"
									height="48"
									src={profileImageData}
									onError={onProfileImageError}
								/>
							</picture>
							<div className="sidebar__profile-info">
								<span className="sidebar__profile-name">{profile[0]?.name || 'User'}</span>
								<span className="sidebar__profile-email">{profile[0]?.email_c || ''}</span>
							</div>
						</NavLink>
					</div>
				</div>
			</aside>
			<div className={`sidebar-overlay ${isOpen ? 'show' : ''}`} id="sidebar-overlay"></div>
		</>
	);
};
